import React from 'react';
import {connect} from 'react-redux';
import ResellerGoogleMap from "../Components/ResellerGoogleMap";
import {load} from "../Actions/ResellerGoogleMap.action";
import {lifecycle} from 'recompose';

let ResellerGoogleMapContainer = (props) => <ResellerGoogleMap {...props} />

const mapStateToProps = state => {

    return {
        resellerData: state.reseller.resellerData,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        load: () => dispatch(load()),
    }
}

ResellerGoogleMapContainer = lifecycle({
    componentDidMount() {
        const {load} = this.props;
        load();
    }
})(ResellerGoogleMapContainer);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ResellerGoogleMapContainer);
